import * as CONSTANTS from '../constants/constants';

export const videoCompleted = (data) => (
    dispatch,
    getState,
    { getFirebase, getFirestore }
  ) => {
      var {courseId,sectionId,lectureId,userId} = data;
      const firestore = getFirestore();
      const fsCompletedRef = firestore.collection(CONSTANTS.COURSES).doc(courseId)
      .collection('sections').doc(sectionId).collection('lectures').doc(lectureId).collection('completed');
      fsCompletedRef.doc(userId).set({userId}).then((docRef)=>{
          console.log('Course completd')
      }).catch((err)=>console.log(err))
  };
  